import { useTranslation } from "react-i18next";

export default function LiveNotification() {
  const { t } = useTranslation();
  return (
    <div className="fixed left-2 md:left-4 bottom-4 md:bottom-6 z-40 w-56 sm:w-64 md:w-72">
      <div className="flex items-center gap-2 md:gap-3 px-3 md:px-4 py-2.5 md:py-3 rounded-xl border bg-emerald-50 border-emerald-200">
        <div className="w-7 h-7 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-white border border-gray-100 flex-shrink-0">
          <i className="ri-money-euro-circle-line text-emerald-600 text-sm md:text-base"></i>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-xs font-bold text-gray-800 truncate leading-tight">Anna M. <span className="font-normal text-gray-400 hidden sm:inline">· Berlin</span></div>
          <div className="text-xs text-gray-500 mt-0.5 leading-tight">
            {t("notif_received")} <strong className="text-gray-800">€19,800</strong>{" "}
            <span className="font-semibold text-emerald-600">({t("notif_plan")})</span>
          </div>
        </div>
        <div className="w-2 h-2 flex items-center justify-center flex-shrink-0">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
          </span>
        </div>
      </div>
    </div>
  );
}
